import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Imagenes de "{name}"',

            dlgUploadTitle: "Actualizar imagen",
            lblFileName: "Nombre del archivo",
            dlgDeleteTitle: "Eliminar mapa",
            dlgDeleteText: "¿Está seguro de eliminar este mapa?",
            lblback: 'Atras',

            btnNew: "AGREGAR IMAGEN",
            btnCancel: "CANCELAR",
            btnDelete: "ELIMINAR",
            btnUpdate: "ACTUALIZAR",

            lblFilter: "Filtrar imágenes",
            aFilter: [
                "Todos",
                "Fotos",
                "Mapas"
            ],
            Foto: 'Foto',
            Mapa: 'Mapa',
            lblFileTypeError: 'Sólo se aceptan imágenes en formato PNG',
        },
        en: {
            moduleTitle: 'Image list for "{name}"',

            dlgUploadTitle: "Refresh Image",
            lblFileName: "File name",
            dlgDeleteTitle: "Delete map",
            dlgDeleteText: "Are you sure to delete this map?",
            lblback: 'Go back',

            btnNew: "ADD IMAGE",
            btnCancel: "CANCEL",
            btnDelete: "ELIMINAR",
            btnUpdate: "REMOVE",

            lblFilter: "Filter images",
            aFilter: [
                "All",
                "Photos",
                "Maps"
            ],

            Foto: 'Photo',
            Mapa: 'Map',
            lblFileTypeError: 'Only images in PNG format are accepted',

        }
    }
}

export default _.merge(messages, defaultMessages)